/**
 *
 * @param key of KeyboardEvent.key
 * @returns
 */
export function isKeyPrintable(key: string) {
  return key.length === 1 || key === " "
}
